// The column key on which the overlap indicator is rendered
export const OVERLAP_COLUMN_KEY = 'totalRevenue';

// Polus (issue #670) serializes isOverlapping as the string "true", not a boolean.
// Accept both forms so the gate stays correct if the serialization is ever fixed upstream.
export const OVERLAP_FLAG_STRING = 'true' as const;

export const OVERLAP_TOOLTIP_FULL =
    'This party is a supplier as well with circular transaction of {circularValue} ({circularPct}%) out of total transaction of {circularTotal}';

export const OVERLAP_TOOLTIP_FALLBACK = 'This party is also a supplier with circular transactions.';

export interface OverlapRow {
    isOverlapping?: string | boolean;
    circularValue?: string;
    circularPct?: string;
    circularTotal?: string;
    totalRevenue?: string;
    [key: string]: unknown;
}

/**
 * Pure function — no React state or effects.
 * Returns the full tooltip copy when all circular fields are present;
 * falls back to the short copy otherwise.
 */
export function buildOverlapTooltip(row: OverlapRow): string {
    if (!row.circularValue || !row.circularPct || !row.circularTotal) {
        return OVERLAP_TOOLTIP_FALLBACK;
    }
    return OVERLAP_TOOLTIP_FULL.replace('{circularValue}', row.circularValue)
        .replace('{circularPct}', row.circularPct)
        .replace('{circularTotal}', row.circularTotal);
}

/**
 * Gate — returns true when the row is flagged as overlapping.
 * Polus (#670) sends isOverlapping as the string "true"; accept a real boolean too.
 */
export function isOverlappingRow(row: OverlapRow): boolean {
    return row?.isOverlapping === OVERLAP_FLAG_STRING || row?.isOverlapping === true;
}
